'use client';

import { useEffect } from 'react';
import { captureGclid } from '@/util/google_tracking_client';

/**
 * Captures gclid from URL parameters and stores as _gcl_aw cookie.
 * Renders nothing — purely a side-effect component.
 */
export default function GclidCapture() {
  useEffect(() => {
    captureGclid();
  }, []);

  return null;
}
